/* @generated from adl module ferovinum.datacontracts.saleproduct */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface SaleProductRawRecord {
  id: common_strings.StringNE;
  productId: common_strings.StringNE;
  hsCode: (string|null);
  externalProductDisplayName: (string|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeSaleProductRawRecord(
  input: {
    id: common_strings.StringNE,
    productId: common_strings.StringNE,
    hsCode: (string|null),
    externalProductDisplayName: (string|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): SaleProductRawRecord {
  return {
    id: input.id,
    productId: input.productId,
    hsCode: input.hsCode,
    externalProductDisplayName: input.externalProductDisplayName,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const SaleProductRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.saleproduct","decl":{"annotations":[{"value":{"datasetName":"raw_sale_product"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"hsCode","default":{"kind":"nothing"},"name":"hsCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"externalProductDisplayName","default":{"kind":"nothing"},"name":"externalProductDisplayName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"SaleProductRawRecord","version":{"kind":"nothing"}}};

export const snSaleProductRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.saleproduct", name:"SaleProductRawRecord"};

export function texprSaleProductRawRecord(): ADL.ATypeExpr<SaleProductRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snSaleProductRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.saleproduct.SaleProductRawRecord" : SaleProductRawRecord_AST
};
